<template>
  <div class="container">
    <div class="col-12 u-h-100">
      <div class="row u-h-100 u-align-items-center u-justify-content-center u-text-align-center">
        <div class="col-12 col-md-8">
          <h1>{{ $t('request_quotation.confirmation.title') }}</h1>
          <p class="subtitle">{{ $t('request_quotation.confirmation.message') }}</p>
          <div class="btn btn--primary" @click="openStepsAndCleanStorage">{{ $t('request_quotation.confirmation.start_new') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './../sass/main.scss';
.container {
  height: 100%;
  //min-height: 100vh;
}
</style>

<script>
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  name: "Confirmation Page",
  mounted () {
    this.trackVirtualPageview();
  },
  methods: {
    trackVirtualPageview () {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.virtualPageview('Confirmation Page');
    },
    openStepsAndCleanStorage () {
      this.resetStore();
      this.$router.push("/steps");
    },
    resetStore() {
      if(sessionStorage)sessionStorage.clear();
      this.$store.commit('setArticle', null);
      this.$store.commit('setBestSystem', undefined);
      this.$store.commit('setChosenItems', undefined);
      this.$store.commit('setColdroom', undefined);
      this.$store.commit('setColdroomSystem', undefined);
      this.$store.commit('setColor', undefined);
      this.$store.commit('setComputedAccessoires', undefined);
      this.$store.commit('setContainerStops', undefined);
      this.$store.commit('setCutOutHeight', undefined);
      this.$store.commit('setCutOutWidth', undefined);
      this.$store.commit('setDividersPerShelf', undefined);
      this.$store.commit('setFrontStopsPerShelf', undefined);
      this.$store.commit('setGravitySheetSwitch', undefined);
      this.$store.commit('setKitFlanges', undefined);
      this.$store.commit('setNumberOfSystems', undefined);
      this.$store.commit('setPostsFrontBack', undefined);
      this.$store.commit('setShelvesPerDoor', undefined);
      this.$store.commit('setShelvesSingleDouble', undefined);
      this.$store.commit('setShelvesWirePlate', undefined);
      this.$store.commit('setSuggestedHeight', undefined);
      this.$store.commit('setTotalSystem', undefined);
    }
  }
}
</script>
